/** @module csi/monitor/WebSocketNodeMonitor */
define([
    "dojo/_base/declare",
    "dojo/topic",
    "csi/comm/GetRequest",
    "csi/comm/WebSocketChannel",
    "./NodeMonitor"
], function (declare, topic, GetRequest, WebSocketChannel, NodeMonitor) {

    const monitors = {};

    /**
     * Send websocket request
     * @param {string} operation
     * @param {string} url
     * @return {boolean}
     */
    function sendOperationOverWebsocket(operation, url) {
        const notifyRequest = new GetRequest("NodeChange", operation, { URL: url });
        return WebSocketChannel.sendAsRequest(notifyRequest);
    }

    const Monitor = declare(NodeMonitor, {
        /**
         * @override
         * Restart monitoring when adding first listener
         */
        addEventListener: function (type, callback) {
            const { url } = this;

            if (!monitors[url]) {
                if (!sendOperationOverWebsocket("StartNodeMonitoring", url)) {
                    console.assert(false, "Websocket connection is down and cannot monitor ", url);
                    return null;
                }
                monitors[url] = this;
            }

            this.inherited(arguments);
        },

        /**
         * @override
         * Remove myself from the list and stop node monitoring when there are no more listeners
         */
        _onDisconnect: function () {
            const { url } = this;
            //console.log("Removing WebSocketNodeMonitor for ", url);
            delete monitors[url];
            sendOperationOverWebsocket("StopNodeMonitoring", url);

            this.inherited(arguments);
        }
    });

    // subscribe to server messages
    topic.subscribe("/csi/servermessage/NodeChanged", (response) => {
        const node = response.NODES.ResultNode[0];
        //console.log("Received NodeChanged from WebSocket. Node=", node);

        const monitor = monitors[node.$URL];
        if (monitor) {
            monitor._dispatchNodeChangedEvent(node);
        }
    });
    topic.subscribe("/csi/servermessage/NodesDeleted", (cnls) => {
        //console.log("Received NodesDeleted from WebSocket. CNLs=", cnls);

        for (const cnl of cnls) {
            const monitor = monitors[cnl];
            if (monitor) {
                monitor._dispatchNodeDeletedEvent(cnl);
            }
        }
    });

    /**
     * WebSocketNodeMonitor factory function.
     * Returns null if there is no WebSocket support or it is disabled on the application level
     * @param {string} url
     * @return {NodeMonitor}
     */
    Monitor.createMonitorForUrl = (url) => {
        if (!sendOperationOverWebsocket("StartNodeMonitoring", url)) {
            return null;
        }

        const monitor = new Monitor(url);
        monitors[url] = monitor;
        // console.log("Created WebSocketNodeMonitor for", url);
        return monitor;
    };

    return Monitor;
});